import { Priorities } from 'Components/SharedComponents/Surveys/types'

export const isCheckInSurveyComplete = ({
  orgMissionChange,
  orgHealthChange,
  priorities,
}: {
  orgMissionChange: string
  orgHealthChange: string
  priorities: Priorities
}) =>
  priorities.firstPriority.category &&
  priorities.secondPriority.category &&
  orgMissionChange !== '' &&
  orgHealthChange !== ''
